import { useStore } from 'vuex';
import { useStore as useVuexSimpleStore } from 'vuex-simple';

import { RooStore } from '@/store/store';

export default function useTypedStore(): RooStore {
  return useVuexSimpleStore(useStore());
}
